import * as React from 'react'
function SvgIndicatorHelp(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 4c8.8 0 16 7.2 16 16s-7.2 16-16 16S4 28.8 4 20 11.2 4 20 4zm0 4C13.4 8 8 13.4 8 20s5.4 12 12 12 12-5.4 12-12S26.6 8 20 8zm0 18a2 2 0 110 4 2 2 0 010-4zm0-16c3.4 0 6 2.6 6 6 0 2.8-1.8 4-3 4.8-1 .6-1 .8-1 1.2l-.005.15A2 2 0 0118 22c0-2.6 1.6-3.8 2.8-4.6 1-.6 1.2-.8 1.2-1.4 0-1.2-.8-2-2-2-.8 0-1.4.4-1.8 1l-.042.076a1.925 1.925 0 01-2.658.724l-.018-.01a2 2 0 01-.734-2.696L14.8 13c1-1.8 3-3 5.2-3z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgIndicatorHelp
